exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrollable-textarea[data-v-7f6de614] {\n  resize: none;\n  overflow: auto;\n  width: 100%;\n  border-color: #000000;\n}\n.scrollable-textarea[data-v-7f6de614]:focus {\n  border-color: #000000;\n  outline: 0;\n  box-shadow: none;\n}\nth[data-v-7f6de614] {\n  font-size: 13px;\n  font-family: Roboto;\n  background-color: #e0ddd9;\n  font-family: Roboto;\n}\ntd[data-v-7f6de614] {\n  font-size: 12px;\n  font-family: Roboto;\n}\nlabel[data-v-7f6de614] {\n  font-weight: 500;\n  color: black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f6de614","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/inventoryReconciliation/inventoryReconciliation.component.scss
// module id = 2196
// module chunks = 0